<template lang="pug">
// start: LOGIN
.row.sb-background
    .main-login.col-xs-10.col-xs-offset-1.col-sm-8.col-sm-offset-2.col-md-4.col-md-offset-4
        .logo.margin-top-30
            img(src='/static/app/images/logo.png', alt='Salesbeat')
            img.sdek-logo(v-if="promo == 'sdek'", src='/static/app/images/sdek-logo.png', alt='СДЭК')
            img.pro_sales-logo(v-else-if="promo == 'pro_sales'", src='/static/app/images/pro_sales-logo.png', alt='ProSales')
            img.magazin_lab-logo(v-else-if="promo == 'magazin_lab'", src='/static/app/images/magazin_lab-logo.png', alt='Magazin-Lab')
            img.good_production-logo(v-else-if="promo == 'good_production'", src='/static/app/images/good_production-logo.png', alt='Magazin-Lab')
            img.internet_expert-logo(v-else-if="promo == 'internet-expert.ru'", src='/static/app/images/internet-expert.svg', alt='Magazin-Lab')
            img.salut-logo(v-else-if="promo == 'salut'", src='/static/app/images/salut.png', alt='Студия Салют')
        // start: LOGIN BOX
        div.padding-30(:class="childClass")
              slot
        // end: LOGIN BOX
    
</template>

<script>
export default {
    name: 'LoginWrapper',
    props: [
        'childClass',
        'promo'
    ]
};
</script>

<style>
.sdek-logo {
    float: right;
    width: 115px!important;
    height: 25px;
    margin-top: 8px;
}
.pro_sales-logo {
    float: right;
    width: 175px!important; 
}
@media (min-width: 992px) and (max-width: 1150px) {
    .pro_sales-logo {
        width: 125px!important;
        margin-top: 5px;
    }
}
.magazin_lab-logo {
    float: right;
    margin-top: -20px;
    width: 90px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/LoginWrapper.vue